export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biorący"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Twórca"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID Biorącego"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID Twórcy"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Płacisz"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otrzymujesz"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czas oczekiwania"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwa"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto bankowe/Portfel"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opis"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak nazwy banku"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak konta bankowego"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie podano nazwy"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie podano konta"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zewnętrzny"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wewnętrzny"])}
}